// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jBr4","footer":"styles_footer__1r3xB","passCodeTooltip":"styles_passCodeTooltip__1KkqJ"};